module.exports = __webpack_public_path__ + "static/media/share-white.37e8c799.svg";